import styled from 'styled-components';

const SectorSpecialist = styled.div`
  .row {
    font-family: 'Open Sans', sans-serif;
    display: flex;
    width: 100%;
    height: 400px;
    gap: 30px;
    padding: 30px;
    margin-top: 120px;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      flex-direction: column-reverse;
      justify-content: flex-end;
      align-items: flex-end;
      margin-top: 100px;
      height: 670px;
      padding: 0;
    }

    .col_1 {
      width: 50%;
      overflow: hidden;
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        height: 250px;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 20px;
      }
    }
    .col_2 {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      gap: 20px;

      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        padding: 0;
        align-items: center;
      }

      h1 {
        font-family: 'Poppins', sans-serif;
        font-size: 2.3rem;
        font-weight: 600;
        letter-spacing: -1px;

        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          text-align: center;
          font-size: 2rem;
        }
      }
      P {
        line-height: 1.9;
        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          text-align: center;
        }
      }
    }
  }
`;
const ResidentialCleaningAgent = styled.div`
  .row {
    font-family: 'Open Sans', sans-serif;
    display: flex;
    width: 100%;
    height: 450px;
    gap: 30px;
    padding: 30px;
    margin-top: 50px;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      flex-direction: column-reverse;
      justify-content: flex-end;
      align-items: flex-end;
      margin-top: 50px;
      height: 600px;
      padding: 0;
    }

    .col_1 {
      width: 50%;
      height: auto;
      overflow: hidden;
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
      }
      img {
        width: 100%;
        object-fit: cover;
        border-radius: 20px;
        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          height: 250px;
        }
      }
    }
    .col_2 {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      gap: 20px;

      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        padding: 0;
      }

      h1 {
        font-family: 'Poppins', sans-serif;
        font-size: 2.3rem;
        font-weight: 600;
        letter-spacing: -1px;

        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          font-size: 2rem;
          text-align: center;
        }
      }
      P {
        line-height: 1.9;
        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          text-align: center;
        }
      }
    }
  }
`;
const OurCommitment = styled.div`
  .row {
    font-family: 'Open Sans', sans-serif;
    display: flex;
    width: 100%;
    height: 400px;
    gap: 30px;
    padding: 30px;
    margin-top: 50px;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      flex-direction: column-reverse;
      height: auto;
      margin-top: 120px;
      justify-content: flex-end;
      padding: 0;
    }

    .col_1 {
      width: 50%;
      overflow: hidden;
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        height: 250px;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 20px;
      }
    }
    .col_2 {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      gap: 20px;

      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        padding: 0;
      }

      h1 {
        font-family: 'Poppins', sans-serif;
        font-size: 2.3rem;
        font-weight: 600;
        letter-spacing: -1px;

        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          font-size: 2rem;
          text-align: center;
        }
      }
      P {
        line-height: 1.9;
        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          text-align: center;
        }
      }
    }
  }
`;

export { SectorSpecialist, OurCommitment, ResidentialCleaningAgent };
